// If name is not supplied, this generator is used and assigns consistent name across all buttons under the group
export const generateNameWithPrefix = (prefix = ''): string => {
    const suffix = new Date().valueOf().toString();
    return prefix.concat(suffix);
};
